export default "__VITE_ASSET__GixQ9Bob__"